import { render, staticRenderFns } from "./blueButton.vue?vue&type=template&id=2e3875cb&scoped=true&"
var script = {}
import style0 from "./blueButton.vue?vue&type=style&index=0&id=2e3875cb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3875cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3875cb')) {
      api.createRecord('2e3875cb', component.options)
    } else {
      api.reload('2e3875cb', component.options)
    }
    module.hot.accept("./blueButton.vue?vue&type=template&id=2e3875cb&scoped=true&", function () {
      api.rerender('2e3875cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/blueButton/blueButton.vue"
export default component.exports